import { CSSInterpolation } from '@ant-design/cssinjs'
import { GlobalToken } from 'antd'

export const genMenuStyle = (
  prefixCls: string,
  token: GlobalToken
): CSSInterpolation => [
  {
    [`.${prefixCls}`]: {
      '.ant-menu-submenu-selected >.ant-menu-submenu-title': {
        backgroundColor: 'rgb(54, 71, 199)',
      },
    },
  },
]
